// Filter dropdown for the analytics pages: same look as the rhinostyle Dropdown filters, with a
// search box that narrows the list as you type (client-side; the lists are already loaded).
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown, DropdownMenuItem, Icon, Input, Scrollbars, UtilitySystem,
} from 'rhinostyle';

const AnalyticsFilterDropdown = ({
  name, label, options, activeId, onSelect, isFiltered, searchPlaceholder, dataCypress, position,
}) => {
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(true); // toggling to false closes the menu (rhinostyle contract)

  const visible = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return options;
    return options.filter((o) => String(o.label).toLowerCase().includes(query));
  }, [options, search]);

  const select = (id) => {
    onSelect(id);
    setSearch('');
    setIsOpen(false);
  };

  return (
    <Dropdown
      wide
      disableScroll
      position={position}
      label={label}
      type={isFiltered ? 'primary' : 'input'}
      outlined={isFiltered}
      name={name}
      dataCypress={dataCypress}
      onClick={() => setSearch('')}
      isOpen={isOpen}
      handleSetIsOpen={setIsOpen}
    >
      <div className="dropdown__menu__container">
        <div className="search__group">
          <Input
            placeholder={searchPlaceholder}
            className="search__input"
            onChange={(inputName, value) => setSearch(value)}
            initialValue={search}
            addon="left"
            type="text"
            name={`${name}Search`}
            autoComplete="off"
          >
            <Icon icon="search" />
          </Input>
        </div>
      </div>
      <div className="dropdown__menu__container u-p-x-0">
        {visible.length > 0 ? (
          <Scrollbars autoHeight autoHeightMax={UtilitySystem.config.resourceSizes.large}>
            {visible.map((o) => (
              <DropdownMenuItem
                key={o.id}
                id={o.id}
                label={o.label}
                icon={activeId === o.id ? 'checkmark' : ''}
                onClick={() => select(o.id)}
              />
            ))}
          </Scrollbars>
        ) : (
          <div className="search__no-results u-p-x">No results</div>
        )}
      </div>
    </Dropdown>
  );
};

AnalyticsFilterDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })).isRequired,
  activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  dataCypress: PropTypes.string,
  position: PropTypes.string,
};

AnalyticsFilterDropdown.defaultProps = {
  activeId: null, isFiltered: false, searchPlaceholder: 'Search', dataCypress: undefined, position: 'bottom',
};

export default AnalyticsFilterDropdown;
